import { Component, OnInit, AfterViewChecked  } from '@angular/core';
import { environment } from 'src/environments/environment';

declare let paypal: any;



@Component({
  selector: 'app-paypal',
  templateUrl: './paypal.component.html',
  styleUrls: ['./paypal.component.css']
})
export class PaypalComponent implements AfterViewChecked {

  addScript = false;
  paypalLoad = true;
  finalAmount = 1;



  paypalConfig = {
    env: environment.seleccionPago,
    client: {
      sandbox: environment.apiSandbox,
      production: environment.apiProduccion
    },
    locale: 'en_US',
    style: {
      size: 'responsive',
      color: 'blue',
      shape: 'pill',
      label: 'pay',
      tagline: 'true',
       fundingicons: 'true'
    },





    commit: true,
    payment: (data, actions) => {

      return actions.payment.create({
        payment: {
          transactions: [
            { amount: { total: this.finalAmount, currency: 'USD' },
            description: 'Compra de permisos de Pesca' }
          ]
        },

      });
    },
    onAuthorize: (data, actions) => {
      return actions.payment.execute().then((payment) => {
        // Do something when payment is successful.
        console.log (payment);

      });
    }
  };




  ngAfterViewChecked(): void {
    if (!this.addScript) {
      this.addPaypalScript().then(() => {
        paypal.Button.render(this.paypalConfig, '#paypal-checkout-btn');
        this.paypalLoad = false;
      });
    }
  }




  addPaypalScript() {
    this.addScript = true;
    return new Promise((resolve, reject) => {
      const scripttagElement = document.createElement('script');
      scripttagElement.src = 'https://www.paypalobjects.com/api/checkout.js';
      scripttagElement.onload = resolve;
      document.body.appendChild(scripttagElement);
    });
  }














}
